import { useSearchParams as useReactSearchParams } from "react-router-dom";

export default function useSearchParams() {
  const [searchParams, setSearchParams] = useReactSearchParams();

  const getParam = (key) => searchParams.get(key);

  const setParams = (params) => {
    const clone = new URLSearchParams(searchParams.toString());
    const setParams = (name) => clone.set(name, params[name]);
    Object.keys(params).forEach(setParams);
    setSearchParams(clone);
  };

  const removeParam = (param) => {
    const clone = new URLSearchParams(searchParams.toString());
    clone.delete(param);
    setSearchParams(clone);
  };

  return { getParam, setParams, removeParam };
}
